export default __webpack_public_path__ + "static/media/guion.bd000e08.svg";